
import React from 'react'

function Deals() {
  return (
    <div>
      
    </div>
  )
}

export default Deals

